import axios from 'axios';
import { CreateDealPayload } from '../types/deal';
import { API_BASE_URL } from '../constants';

const api = axios.create({
  baseURL: API_BASE_URL,
});

const getHeaders = (accessToken: string) => ({
  'Authorization': `Bearer ${accessToken}`
});

export const getConfig = async () => {
  const response = await api.get('/hubspot-config');
  return response.data;
};

export const getDeals = async (partnerName: string, accessToken: string) => {
  const response = await api.get(`/deals?partnerName=${partnerName}`, { headers: getHeaders(accessToken) });
  return response.data;
};

export const createDeal = async (dealData: CreateDealPayload, accessToken: string) => {
  const response = await api.post('/deals', dealData, { headers: getHeaders(accessToken) });
  return response.data;
};

export const getOwnerByEmail = async (email: string, accessToken: string) => {
  const response = await api.get(`/owners?email=${email}`, { headers: getHeaders(accessToken) });
  return response.data;
};

export const getFocusApplications = async (accessToken: string) => {
  const response = await api.get('/focus-applications', { headers: getHeaders(accessToken) });
  return response.data;
};

export const getDealStages = async (accessToken: string) => {
  const response = await api.get('/deal-stages', { headers: getHeaders(accessToken) });
  return response.data;
};

export const getOwnerById = async (ownerId: string, accessToken: string) => {
  const response = await api.get(`/owners/${ownerId}`, { headers: getHeaders(accessToken) });
  return response.data;
};

export const updateDeal = async (dealId: string, data: CreateDealPayload, accessToken: string) => {
  const response = await api.patch(`/deals/${dealId}`, data, { headers: getHeaders(accessToken) });
  return response.data;
};

export const getDealNotes = async (dealId: string, accessToken: string) => {
  const response = await api.get(`/deals/${dealId}/notes`, { headers: getHeaders(accessToken) });
  return response.data;
};

export const getAssociatedPartners = async (accessToken: string) => {
  const response = await api.get('/associated-partners', { headers: getHeaders(accessToken) });
  return response.data;
}; 
